/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './LengthCounter.style';

type Props = {
  count: number,
  maxLength: number,
};

const useStyles = createUseThemeStyles(styles);

const LengthCounter = ({ count, maxLength }: Props): React.Node => {
  const classes = useStyles();

  // Classes
  const rootClasses = classNames(classes.root, {
    [`${classes['root-error']}`]: count > Number(maxLength),
    [`${classes['root-maxValue']}`]: count === Number(maxLength),
  });

  return <span className={rootClasses}>{`${count}/${maxLength}`}</span>;
};

export default React.memo<Props>(LengthCounter);
